import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

// Design-system fonts (Chonburi, Playfair Display, Oswald, Prompt) load from
// Google Fonts in index.html — the same families the design system bundle uses.
import App from './App'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
